(function () {
  'use strict';

  var SELECTOR = '#cart-offer-progress';

  function parseJson(id) {
    var el = document.getElementById(id);
    if (!el) return [];
    try {
      return JSON.parse(el.textContent || el.innerText || '[]') || [];
    } catch (err) {
      console.error('CartOfferProgress: invalid JSON in #' + id, err);
      return [];
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('Cart fetch failed');
      return r.json();
    });
  }

  function countCollectionQty(cart, productIds) {
    if (!productIds || !productIds.length || !cart || !cart.items) return 0;
    var idSet = {};
    productIds.forEach(function (id) {
      idSet[String(id)] = true;
    });
    return cart.items.reduce(function (sum, item) {
      if (idSet[String(item.product_id)]) {
        return sum + (parseInt(item.quantity, 10) || 0);
      }
      return sum;
    }, 0);
  }

  function interpolate(template, vars) {
    if (!template) return '';
    var result = template;
    Object.keys(vars).forEach(function (key) {
      result = result.replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'gi'), vars[key]);
    });
    return result;
  }

  function formatMoney(cents, format) {
    if (typeof window.formatMoney === 'function') {
      return window.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2);
    return amount;
  }

  function formatMoneyPlain(cents, format) {
    var formatted = formatMoney(cents, format);
    if (!formatted || formatted.indexOf('<') === -1) return formatted;
    var el = document.createElement('span');
    el.innerHTML = formatted;
    return el.textContent || el.innerText || formatted;
  }

  function pickBuyXGetYOffer(offers, cart) {
    var active = offers
      .map(function (offer) {
        return Object.assign({}, offer, {
          collection_qty: countCollectionQty(cart, offer.collection_product_ids),
        });
      })
      .filter(function (offer) {
        return offer.collection_qty > 0;
      });

    if (!active.length) return null;

    var buyMinMet = active.filter(function (o) {
      return o.collection_qty >= o.customer_buys;
    });

    if (buyMinMet.length) {
      buyMinMet.sort(function (a, b) {
        if (b.collection_qty !== a.collection_qty) return b.collection_qty - a.collection_qty;
        return String(a.id).localeCompare(String(b.id));
      });
      return buyMinMet[0];
    }

    active.sort(function (a, b) {
      if (b.customer_buys !== a.customer_buys) return b.customer_buys - a.customer_buys;
      if (b.collection_qty !== a.collection_qty) return b.collection_qty - a.collection_qty;
      return String(a.id).localeCompare(String(b.id));
    });
    return active[0];
  }

  function computeBuyProgress(offer) {
    var qty = offer.collection_qty;
    var buys = offer.customer_buys;
    var gets = offer.customer_gets;
    var buyRatio = Math.min(qty / buys, 1);
    var buyProgress = buyRatio * 50;
    var getProgress = 0;

    if (qty >= buys) {
      getProgress = Math.min((qty - buys) / gets, 1) * 50;
    }

    return Math.min(buyProgress + getProgress, 100);
  }

  function getBuyMessage(offer, root) {
    var qty = offer.collection_qty;
    var buys = offer.customer_buys;
    var gets = offer.customer_gets;
    var vars = {
      collection_url: offer.collection_url || '#',
      collection_title: offer.collection_title || '',
      offer_name: offer.offer_name || '',
      count: '0',
    };

    if (qty >= buys + gets) {
      return interpolate(root.dataset.msgBuyUnlocked, vars);
    }

    if (qty >= buys) {
      vars.count = String(Math.max(0, gets - (qty - buys)));
      return interpolate(root.dataset.msgBuyAddFree, vars);
    }

    vars.count = String(Math.max(0, buys - qty));
    return interpolate(root.dataset.msgBuyAddMore, vars);
  }

  function renderBuyPanel(panel, offer, root) {
    var progress = computeBuyProgress(offer);
    var fill = panel.querySelector('[data-progress-fill]');
    var message = panel.querySelector('[data-offer-message]');
    var buyTop = panel.querySelector('[data-buy-milestone-top]');
    var buyBottom = panel.querySelector('[data-buy-milestone-bottom]');
    var getTop = panel.querySelector('[data-get-milestone-top]');
    var getBottom = panel.querySelector('[data-get-milestone-bottom]');
    var buyMilestone = panel.querySelector('[data-buy-milestone]');
    var getMilestone = panel.querySelector('[data-get-milestone]');

    if (message) message.innerHTML = getBuyMessage(offer, root);
    if (fill) fill.style.width = progress + '%';

    if (buyTop) {
      buyTop.textContent = interpolate(root.dataset.msgBuyPhaseLabel, {
        count: String(offer.customer_buys),
      });
    }
    if (buyBottom) {
      var itemsTemplate =
        offer.customer_buys === 1 ? root.dataset.msgItemsOne : root.dataset.msgItemsOther;
      buyBottom.textContent = interpolate(itemsTemplate, {
        count: String(offer.customer_buys),
      });
    }
    if (getTop) {
      getTop.textContent = interpolate(root.dataset.msgGetPhaseLabel, {
        count: String(offer.customer_gets),
      });
    }
    if (getBottom) {
      getBottom.textContent = interpolate(root.dataset.msgFreeLabel, {
        count: String(offer.customer_gets),
      });
    }

    if (buyMilestone) {
      buyMilestone.classList.toggle('is-reached', offer.collection_qty >= offer.customer_buys);
    }
    if (getMilestone) {
      getMilestone.classList.toggle(
        'is-reached',
        offer.collection_qty >= offer.customer_buys + offer.customer_gets
      );
    }
  }

  function sortDiscountOffers(offers) {
    return offers.slice().sort(function (a, b) {
      return a.cart_value_cents - b.cart_value_cents;
    });
  }

  function computeDiscountProgress(offers, cartTotal) {
    var count = offers.length;
    if (!count) return 0;

    var segmentWidth = 100 / count;
    var lastThreshold = offers[count - 1].cart_value_cents;

    if (cartTotal >= lastThreshold) return 100;

    for (var i = 0; i < count; i++) {
      if (cartTotal < offers[i].cart_value_cents) {
        var prevThreshold = i > 0 ? offers[i - 1].cart_value_cents : 0;
        var nextThreshold = offers[i].cart_value_cents;
        var range = nextThreshold - prevThreshold;
        var segmentProgress = range > 0 ? (cartTotal - prevThreshold) / range : 0;
        segmentProgress = Math.min(Math.max(segmentProgress, 0), 1);
        return i * segmentWidth + segmentProgress * segmentWidth;
      }
    }

    return 100;
  }

  function getDiscountState(offers, cartTotal, root) {
    var sorted = sortDiscountOffers(offers);
    if (!sorted.length) return null;

    var progress = computeDiscountProgress(sorted, cartTotal);
    var unlocked = sorted.filter(function (o) {
      return cartTotal >= o.cart_value_cents;
    });
    var next = sorted.find(function (o) {
      return cartTotal < o.cart_value_cents;
    });

    var message = '';
    var moneyFormat =
      root.dataset.moneyFormat ||
      (window.MinimogSettings && window.MinimogSettings.money_format) ||
      '${{amount}}';

    if (!next) {
      message = root.dataset.msgDiscountAllUnlocked || '';
    } else if (unlocked.length) {
      var lastUnlocked = unlocked[unlocked.length - 1];
      message = interpolate(root.dataset.msgDiscountUnlockedNext, {
        percent: String(lastUnlocked.offer_percentage),
        amount: formatMoney(next.cart_value_cents - cartTotal, moneyFormat),
        next_percent: String(next.offer_percentage),
      });
    } else {
      message = interpolate(root.dataset.msgDiscountAway, {
        amount: formatMoney(next.cart_value_cents - cartTotal, moneyFormat),
        percent: String(next.offer_percentage),
      });
    }

    return {
      offers: sorted,
      progress: progress,
      message: message,
      unlocked: unlocked,
      moneyFormat: moneyFormat,
    };
  }

  function renderDiscountPanel(panel, state, root) {
    var fill = panel.querySelector('[data-progress-fill]');
    var message = panel.querySelector('[data-offer-message]');
    var markersContainer = panel.querySelector('[data-discount-markers]');

    if (message) message.innerHTML = state.message;
    if (fill) fill.style.width = state.progress + '%';

    if (!markersContainer) return;

    markersContainer.innerHTML = '';
    var count = state.offers.length;

    state.offers.forEach(function (offer, index) {
      var position = ((index + 1) / count) * 95;
      var milestone = document.createElement('div');
      milestone.className = 'cart-offer-progress__milestone';
      if (state.unlocked.some(function (u) { return u.id === offer.id; })) {
        milestone.classList.add('is-reached');
      }
      milestone.style.left = position + '%';

      var top = document.createElement('span');
      top.className = 'cart-offer-progress__milestone-top';
      top.textContent = interpolate(root.dataset.msgMilestonePercent, {
        percent: String(offer.offer_percentage),
      });

      var dot = document.createElement('span');
      dot.className = 'cart-offer-progress__milestone-dot';
      dot.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>';

      var bottom = document.createElement('span');
      bottom.className = 'cart-offer-progress__milestone-bottom';
      bottom.textContent = interpolate(root.dataset.msgMilestoneThreshold, {
        amount: formatMoneyPlain(offer.cart_value_cents, state.moneyFormat),
      });

      milestone.appendChild(top);
      milestone.appendChild(dot);
      milestone.appendChild(bottom);
      markersContainer.appendChild(milestone);
    });
  }

  function render(root, cart) {
    if (!root) return;

    var buyOffers = parseJson('buy-x-get-y-offers-json');
    var discountOffers = parseJson('order-discount-offers-json');
    var buyPanel = root.querySelector('.cart-offer-progress__panel--buy');
    var discountPanel = root.querySelector('.cart-offer-progress__panel--discount');

    var activeBuyOffer = pickBuyXGetYOffer(buyOffers, cart);

    if (activeBuyOffer) {
      root.hidden = false;
      if (buyPanel) buyPanel.hidden = false;
      if (discountPanel) discountPanel.hidden = true;
      renderBuyPanel(buyPanel, activeBuyOffer, root);
      return;
    }

    if (cart.item_count > 0 && discountOffers.length) {
      var discountState = getDiscountState(discountOffers, cart.total_price, root);
      if (discountState) {
        root.hidden = false;
        if (buyPanel) buyPanel.hidden = true;
        if (discountPanel) discountPanel.hidden = false;
        renderDiscountPanel(discountPanel, discountState, root);
        return;
      }
    }

    root.hidden = true;
    if (buyPanel) buyPanel.hidden = true;
    if (discountPanel) discountPanel.hidden = true;
  }

  function refresh() {
    var root = document.querySelector(SELECTOR);
    if (!root) return;

    fetchCart()
      .then(function (cart) {
        render(root, cart);
      })
      .catch(function () {
        render(root, { items: [], item_count: 0, total_price: 0 });
      });
  }

  function init() {
    refresh();
  }

  window.CartOfferProgress = window.CartOfferProgress || {
    init: init,
    refresh: refresh,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart.afterUpdate'].forEach(function (eventName) {
    window.addEventListener(eventName, refresh);
  });

  if (typeof MinimogTheme !== 'undefined' && MinimogTheme.pubSubEvents && window.MinimogEvents) {
    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, refresh);
  }
})();
